import TdInfoCell from "../../../table/cells/td-info-cell"
import LeadInfoCell from "./cells/lead-info-cell"
import ExpandableObjectViewer from "../../../expandable-object-viewer"
import {
  DEFAULT_DATETIME_COMMA_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"
import { BBColumnDef, LeadLogStat } from "../../../../../types"

export const getLeadListColumns = (): BBColumnDef<LeadLogStat>[] => [
  {
    id: "lead-detail",
    header: "Lead Detail",
    meta: { headerClassName: "!pl-0 pr-3 md:pr-5 pt-0 pb-3 md:pb-5" },
    accessorFn: row => row.name,
    footer: props => props.column.id,
    cell: props => <LeadInfoCell info={props.row.original} />
  },
  {
    id: "date-and-time",
    header: "Date & Time",
    meta: { headerClassName: "min-w-52 px-3 md:px-5 pt-0 pb-3 md:pb-5" },
    accessorFn: row => row.created,
    footer: props => props.column.id,
    cell: props => (
      <TdInfoCell
        info={formatDateTimeFromTimestamp(
          props.row.original.timestamp?.toString(),
          DEFAULT_DATETIME_COMMA_FORMAT
        )}
        customContainerClass="p-3 md:p-5 align-top"
        customTextClass="whitespace-pre-wrap leading-6"
      />
    )
  },
  {
    id: "owner",
    header: "Owner",
    meta: { headerClassName: "px-3 md:px-5 pt-0 pb-3 md:pb-5" },
    accessorFn: row => row.owneremail,
    footer: props => props.column.id,
    cell: props => (
      <TdInfoCell
        info={props.row.original.owneremail}
        customContainerClass="p-3 md:p-5 align-top"
        customTextClass="whitespace-pre-wrap break-words leading-6"
      />
    )
  },
  {
    id: "source",
    header: "Source",
    meta: { headerClassName: "px-3 md:px-5 pt-0 pb-3 md:pb-5" },
    accessorFn: row => row.source,
    footer: props => props.column.id,
    cell: props => (
      <TdInfoCell
        info={props.row.original.source}
        customContainerClass="p-3 md:p-5 align-top"
        customTextClass="whitespace-pre-wrap break-words leading-6"
      />
    )
  },
  {
    id: "detail",
    header: "Detail",
    meta: { headerClassName: "pl-3 md:pl-5 pr-0 pt-0 pb-3 md:pb-5" },
    colSpan: 2,
    accessorFn: row => row.email,
    footer: props => props.column.id,
    cell: props => (
      <td
        className="whitespace-nowrap pl-3 md:pl-5 pr-0 py-3 md:py-5 align-top"
        colSpan={2}
      >
        <div className="whitespace-pre-wrap break-words">
          <ExpandableObjectViewer
            data={props.row.original.details}
            isStringified
          />
        </div>
      </td>
    )
  }
]
